import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Form from '.';

export interface INewsletterProps extends IBaseElementProps {
	heading?: string;
	text?: string;
}

/**
 * Newsletter
 * @block
 * @requiresHooks
 * @icon feedback
 */
const Newsletter: React.FC<INewsletterProps> = ({
	className,
	classNames = [],
	heading,
	text,
	children,
}) => (
	<div className={className || cn('newsletter', ...classNames)}>
		<div className="container">
			<div className="newsletter__content">
				{heading && <h2 className="newsletter__heading">{heading}</h2>}
				{text && <div className="newsletter__text">{text}</div>}
			</div>
			<div className="newsletter__form">
				<Form>{children}</Form>
			</div>
		</div>
	</div>
);

export default Newsletter;
